import * as USER_ACTION from 'constant/action/user'
import { handleActions } from 'redux-actions'

const initialState = {
  allUsers: [],
  pagination: {},
  userTypes: [],
  users: {}
}

export default handleActions(
  {
    [USER_ACTION.UPDATE_USERS]: (state, action) => ({
      ...state,
      users: action.payload
    }),
    [USER_ACTION.UPDATE_ALL_USERS]: (state, action) => ({
      ...state,
      allUsers: action.payload
    }),
    [USER_ACTION.UPDATE_USER_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [USER_ACTION.UPDATE_USER_TYPES]: (state, action) => ({
      ...state,
      userTypes: action.payload
    })
  },
  initialState
)
